import { connect, ConnectedProps } from 'react-redux'
import TableMaterials from '../../../../../../../../specificComponents/Product/Tables/TableMaterials'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { CategoriesPayload } from '../../../../../../../../utils/reducers/products/categories'
import { SpecificPriceRulesPayload } from '../../../../../../../../utils/reducers/products/specificPriceRules'
import { ModalFullCentered, CloseLateralModalSimple } from '../../../../../../../Modal'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'

type MaterialsListingModalProps = ReduxCategories & ModalEditComponentProps & {}

const MaterialsListingModal: React.FC<MaterialsListingModalProps> = ({...rest}) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
            <TableMaterialsConnect setTableInstance={() => { }} userPermissions={getUserPermissions('product.material') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={() => rest.setOpened(null)}/>
        </ModalFullCentered>
    )
}

const categoriesDispatch = {
    setCategories: (payload: CategoriesPayload) => ({ type: 'CHANGE_CATEGORIES', payload }),
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

type ReduxCategories = ConnectedProps<typeof categoriesConnect>
const mapCategoriesConnector = (state: AllReduxPayloads) => ({ categories: state.categories, specificPriceRules: state.specificPriceRules })
const categoriesConnect = connect(mapCategoriesConnector, categoriesDispatch)

const categoriesConnectLoading = withLoading(TableMaterials, [{ fetchUrl: '/api/app/product/category/getAllCategories', propName: 'categories', setFunctionName: 'setCategories' }, { fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const TableMaterialsConnect = categoriesConnect(categoriesConnectLoading)

export default MaterialsListingModal